import i18n from '@/i18n';

export const PHRASES_GET_MICROCERT = [
  i18n.t('microcertificates.phrasesLoader.generatingMicrocertificate'),
  i18n.t('microcertificates.phrasesLoader.validatingProgress'),
  i18n.t('microcertificates.phrasesLoader.checkingGrades'),
  i18n.t('microcertificates.phrasesLoader.checkingClasses'),
  i18n.t('microcertificates.phrasesLoader.addingTheMinutes'),
];

export const PHRASES_SHARING = [
  i18n.t('microcertificates.phrasesLoader.gublishingAchievement'),
  i18n.t('microcertificates.phrasesLoader.creatingPost'),
  i18n.t('microcertificates.phrasesLoader.validatingAuthorizations'),
  i18n.t('microcertificates.phrasesLoader.confirmingIdentity'),
  i18n.t('microcertificates.phrasesLoader.verifyingPermissions'),
];
